















import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';

import LoraHardwareStore from '@/store/lora/LoraHardware.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class LoraRegionEditor extends Mixins<BaseComponent>(BaseComponent) {

  @Inject(Symbol.for('ILoraHardwareService'))
  private loraHardwareService!: ILoraHardwareService;

  private loraHardwareStore: LoraHardwareStore = getModule(LoraHardwareStore, this.$store);

  @Prop()
  private region!: string;

  private regions: string[] | null = null;

  private async mounted() {
    await this.loraHardwareStore.fetchAvailableRegions();
    this.regions = await this.loraHardwareStore.AvailableRegions;

    if (this.region) {
      if (!this.regions) {
        this.regions = [this.region];
      } else if (!this.regions.includes(this.region)) {
        this.regions.push(this.region);
      }
    }
  }
}
